import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { getSectors } from "src/store/system/saga";
import { SectorDto } from "src/store/system/type";
import { createAssetTypeSaga } from "src/store/asset-types/saga";
import * as Yup from "yup";
import { ClientCalllogDto, ClientDetailDto } from "src/store/clients/type";
import { CalllogStatusDto } from "src/store/calllog-status/type";
import { getCalllogStatusListSaga } from "src/store/calllog-status/saga";
import {
  createClientCallogs,
  updateClientCallogs,
} from "src/store/clients/saga";

const CalllogCreateForm = ({
  onHide,
  open,
  onSuccessClick,
  data,
}: {
  data: ClientCalllogDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [status, setStatus] = useState<CalllogStatusDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getCalllogStatusListSaga({
          payload: {
            onSuccess: (m, p) => setStatus(p),
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Clients.Calllogs.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          Id: data.Id,
          ClientId: data.ClientId,
          Note: data.Note,
          TalkedWith: data.TalkedWith,
          NextCallDate: data.NextCallDate,
          NextCallNote: data.NextCallNote,
          ClientCallLogStatusId: data.ClientCallLogStatusId,
        }}
        validationSchema={Yup.object().shape({
          Note: Yup.string().required(t("Required").toString()),
          TalkedWith: Yup.string().required(t("Required").toString()),
        })}
        onSubmit={(values) => {
          dispatch(
            updateClientCallogs({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
              id: data.Id,
            })
          );
        }}
        inputs={[
          {
            field: "TalkedWith",
            label: t("Clients.Calllogs.TalkedWith").toString(),
            type: "textarea",
          },
          {
            field: "Note",
            label: t("Clients.Calllogs.Note").toString(),
            type: "textarea",
          },
          {
            field: "NextCallDate",
            label: t("Clients.Calllogs.NextCallDate").toString(),
            type: "datetime-local",
          },
          {
            field: "NextCallNote",
            label: t("Clients.Calllogs.NextCallNote").toString(),
            type: "textarea",
          },
        ]}
      />
    </React.Fragment>
  );
};
export default CalllogCreateForm;
